import React, { useEffect, useContext, useState } from "react";
import {
  BootstrapTable,
  TableHeaderColumn,
  ClearSearchButton,
} from "react-bootstrap-table";
import swal from "sweetalert2";
import * as IconlyPack from "react-iconly";
import { toast } from "react-toastify";
import EditFamilleSoinModal from "../../Modals/EditFamilleSoinModal";
import ShowFamilleSoinsModal from "../../Modals/ShowFamilleSoinsModal";
import { DataContext } from "../../store/GlobalState";
import { getData } from "../../utils/fetchData";
import FamilleSoinsSkeleton from "./FamilleSoinsSkeleton";
import FamilleSoins from "../../Services/FamilleSoins";

const FamilleSoinsTable = () => {
  const { state, dispatch } = useContext(DataContext);

  const { auth, list_famille_soins } = state;

  var [isPageLoading, setIsPageLoading] = useState(true);
  const requestConfig = {
    headers: {
      Authorization: `Bearer ${auth?.token}`,
    },
  };

  useEffect(() => {
    if (auth?.token && auth?.user?.id) {
      getData("familledesoin/", auth.token).then((response) => {
        dispatch({
          type: "LIST_FAMILLE_SOINS",
          payload: response.results.sort((a, b) => b?.id - a?.id),
        });
        setIsPageLoading(false);
      });
    }
  }, [auth]);

  var handleClearButtonClick = (onClick) => {
    console.log("This is my custom function for ClearSearchButton click event");
    onClick();
  };

  var createCustomClearButton = (onClick) => {
    return (
      <ClearSearchButton
        btnText="Effacer"
        btnContextual="btn-warning"
        className="my-custom-class"
        onClick={(e) => handleClearButtonClick(onClick)}
      />
    );
  };

  const options = {
    clearSearch: true,
    clearSearchBtn: createCustomClearButton,
    noDataText: "Aucune donnée disponible",
  };

  const onDelete = (id) => {
    swal
      .fire({
        title: "Êtes vous sûr de vouloir supprimer cette famille de soins ?",
        customClass: {
          confirmButton: "btn-success",
          cancelButton: "btn-danger",
        },
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          var deleteRequest = FamilleSoins.deleteFamilleSoin(id, requestConfig);
          return deleteRequest
            .then((response) => {
              getData("familledesoin/", auth.token).then((response) => {
                dispatch({
                  type: "LIST_FAMILLE_SOINS",
                  payload: response.results.sort((a, b) => b?.id - a?.id),
                });
                setIsPageLoading(false);
              });
            })
            .catch((error) => {
              swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          toast.success("Famille de soins supprimée avec succès.");
        }
      });
  };

  const typeFormat = (cell, row) => {
    return cell?.length;
  };
  const actionFormatter = (cell, row) => {
    return (
      <div className="table-actions-btn-container">
        <button className="action-btn show-btn" title="Details">
          <IconlyPack.Show
            set="light"
            primaryColor="#C8C8C8"
            className="action-btn-icon action-show-icon"
            data-toggle="modal"
            data-target=".show-familleSoins-modal"
            onClick={() => getItem(row)}
          />
        </button>
        <button className="action-btn edit-btn" title="Modification">
          <IconlyPack.Edit
            set="light"
            primaryColor="#C8C8C8"
            className="action-btn-icon action-edit-icon"
            data-toggle="modal"
            data-target=".edit-familleSoins-modal"
            onClick={() => getItem(row)}
          />
        </button>
        <button className="action-btn delete-btn" title="Archivage">
          <IconlyPack.Delete
            set="light"
            primaryColor="#C8C8C8"
            className="action-btn-icon action-delete-icon"
            onClick={() => onDelete(row?.id)}
          />
        </button>
      </div>
    );
  };

  const getItem = (item) => {
    console.log("item", item);
    dispatch({
      type: "FAMILLE_SOINS",
      payload: item,
    });
  };
  return (
    <div className="child-table-container">
      <div className="table-body-container">
        <div className="row easypm-table-row m-t-50 m-b-50">
          <div className="col-md-12 easypm-table-col">
            {isPageLoading && <FamilleSoinsSkeleton />}
            {!isPageLoading && (
              <div className="table-container">
                <BootstrapTable
                  data={list_famille_soins}
                  striped={true}
                  hover={true}
                  condensed={true}
                  multiColumnSort={2}
                  options={options}
                  pagination
                  search={false}
                  version="4"
                  bordered={false}
                >
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1F497D",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    dataField="id"
                    isKey={true}
                    hidden={true}
                  >
                    ID
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1F497D",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    dataField="nom"
                    width="100"
                    // dataAlign="center"
                  >
                    Nom
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1F497D",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    width="100"
                    // dataAlign="center"
                    dataField="typedesoin"
                    dataFormat={(cell, row) => typeFormat(cell, row)}
                  >
                    Nombre de Type de soins
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1F497D",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                      padding: 15,
                    }}
                    width="100"
                    // dataAlign="center"
                    dataField="id"
                    dataFormat={(cell, row) => actionFormatter(cell, row)}
                  >
                    Action
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            )}
          </div>
        </div>
        <div
          className="modal fade easypm-modal edit-familleSoins-modal"
          id="EditFSModalItem"
          tabIndex="-1"
          data-backdrop="static"
          aria-labelledby="EditFSModalItemLabel"
          aria-hidden="true"
        >
          <EditFamilleSoinModal />
        </div>
        <div
          className="modal fade easypm-modal show-familleSoins-modal"
          id="ShowFSModalItem"
          tabIndex="-1"
          data-backdrop="static"
          aria-labelledby="ShowFSModalItemLabel"
          aria-hidden="true"
        >
          <ShowFamilleSoinsModal />
        </div>
      </div>
    </div>
  );
};

export default FamilleSoinsTable;
